import { Decorator } from 'final-form';
import createDecorator from 'final-form-calculate';

import { CertificateDetailsModel, ComponentDetailsModel } from 'models/certificate.model';

const calculateOverallRecycledPercentages = (components: ComponentDetailsModel[]) => {
  const percentRecycled = components?.reduce(
    (overallRecycledPercentages: number, component: ComponentDetailsModel) =>
      overallRecycledPercentages + (component.percentRecycled * component.percentShare) / 100,
    0
  );

  return isNaN(percentRecycled) ? 0 : percentRecycled;
};

export const overallRecycledPercentagesDecorator = createDecorator(
  {
    field: /components\[\d+\]\.percentRecycled/,
    updates: (_, __, allValues) => ({
      percentRecycled: calculateOverallRecycledPercentages(
        (allValues as CertificateDetailsModel).components ?? []
      ),
    }),
  },
  {
    field: /components\[\d+\]\.percentShare/,
    updates: (_, __, allValues) => ({
      percentRecycled: calculateOverallRecycledPercentages(
        (allValues as CertificateDetailsModel).components ?? []
      ),
    }),
  }
) as Decorator<CertificateDetailsModel>;
